/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/prop-types */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import isNil from 'lodash/isNil';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import { CheckOutlined } from '@ant-design/icons';
import Link from '@material-ui/core/Link';
import Image from 'components/Image';
import ShopIcon from 'assets/icons/shop.svg';
import FactoryIcon from 'assets/icons/factory.svg';
import { valueOrUnknown } from 'util/icwUtility';
import { StyledButton } from 'views/AddProduct/components/Elements';

import classes from './ProductLinkageItem.module.scss';

const IconText = ({ icon, alt, text }) => (
  <Box display='flex' marginTop='10px' alignItems='center'>
    <img
      src={icon}
      alt={alt}
      style={{
        width: 16,
        height: 16,
        marginRight: 4,
      }}
    />
    <Typography className={classes.normalText}>{text}</Typography>
  </Box>
);

export const ProductInfo = ({
  isLastItem = false,
  image,
  name,
  itemNo,
  supplierName,
  factoryName,
}) => {
  return (
    <Box
      className={clsx(classes.productInfo, {
        [classes.lastProductInfo]: isLastItem,
      })}>
      <Image src={image} alt={name} width='60px' height='40px' />
      <Box display='flex' flexDirection='column' marginLeft='16px'>
        <Typography className={classes.title}>{name}</Typography>
        <Typography className={classes.normalText}>{itemNo}</Typography>
        <IconText icon={ShopIcon} alt='Shop Icon' text={valueOrUnknown(supplierName)} />
        <IconText
          icon={FactoryIcon}
          alt='Factory Icon'
          text={valueOrUnknown(factoryName, 'No Factory Linkage')}
        />
      </Box>
    </Box>
  );
};

const ProductLinkageItem = ({
  index = null,
  data, // { id, name, image, itemNo, supplierName, factoryName }
  isLastItem = false,
  usingHideNoNumber = true,
  usingViewProfile = false,
  usingSelected = false,
  isSelected = false,
  usingUnlink = false,
  onClickViewProfile,
  onClickSelect,
  onClickUnlink,
}) => {
  const { id } = data;

  return (
    <Box
      display='flex'
      alignItems='center'
      className={clsx(classes.container, { [classes.useBorderBottom]: usingSelected })}>
      {!usingHideNoNumber && !isNil(index) && (
        <Typography
          className={classes.normalText}
          style={{
            marginRight: 12,
            marginBottom: 12,
          }}>{`${index > 8 ? Number(index + 1) : `0${Number(index + 1)}`}`}</Typography>
      )}
      <ProductInfo isLastItem={isLastItem} {...data} />
      {usingViewProfile && (
        <Link
          component={RouterLink}
          to={`/product/profile/${id}`}
          className={classes.linkText}
          onClick={onClickViewProfile}>
          View Profile
        </Link>
      )}
      {usingSelected && (
        <Box marginLeft='auto'>
          <StyledButton
            className={classes.selectButton}
            buttonProps={{
              color: 'primary',
              variant: !isSelected ? 'outlined' : 'contained',
              ghost: !isSelected,
              startIcon: isSelected ? <CheckOutlined /> : null,
              onClick: () => {
                if (onClickSelect) {
                  onClickSelect(data);
                }
              },
            }}>
            {isSelected ? 'Selected' : 'Select'}
          </StyledButton>
        </Box>
      )}
      {usingUnlink && (
        <Box marginLeft='auto'>
          <StyledButton
            buttonProps={{
              nonBackground: true,
              color: 'error',
              variant: 'outlined',
              onClick: onClickUnlink,
            }}>
            Unlink
          </StyledButton>
        </Box>
      )}
    </Box>
  );
};

export default ProductLinkageItem;
